export type LandingVersion = 'new' | 'legacy' | 'nox'

// NOX 品牌專用 domain（含 www 變體）
const NOX_DOMAINS = ['data-contributor.nox-ai.io']

const isNoxDomain = (host: string): boolean => {
  const h = host.toLowerCase()
  return NOX_DOMAINS.some(d => h === d || h === `www.${d}`)
}

export const resolveLandingVersion = (): LandingVersion => {
  // 1. 環境變數 / meta tag 明確指定 → 直接用（本地以 REACT_APP_LANDING_VERSION 覆蓋；
  //    staging 可在 drone pipeline 設 landing_version=nox 先測）
  const raw = document.getElementsByName('landing-version')[0]?.getAttribute('content')
  if (raw === 'nox') return 'nox'
  if (raw === 'new') return 'new'
  if (raw === 'legacy') return 'legacy'

  // 2. 沒明確指定時，依 domain 自動判斷
  if (isNoxDomain(window.location.hostname)) return 'nox'

  // 3. 其他 domain（如 sp.sofinx.com、localhost）預設走原始版
  return 'legacy'
}

export const LANDING_VERSION: LandingVersion = resolveLandingVersion()
